import React, { useEffect, useState } from "react";
import useAxios from "./useAxios";

const useTokenValidation = (type) => {
  const api = useAxios();
  const [loading, setLoading] = useState(true);

  const logoutUser = () => {
    localStorage.removeItem("user.token");
    localStorage.removeItem("user.id");
    localStorage.removeItem("user.name");
    localStorage.removeItem("user.email");
    localStorage.removeItem("user.role");
    window.location.replace("/");
  };

  const logoutCandidate = () => {
    localStorage.removeItem("candidate.token");
    localStorage.removeItem("candidate.id");
    localStorage.removeItem("candidate.name");
    localStorage.removeItem("candidate.email");
    localStorage.removeItem("candidate.role");
    window.location.replace("/careers");
  };

  const logoutConsultant = () => {
    localStorage.removeItem("consultant.token");
    localStorage.removeItem("consultant.id");
    localStorage.removeItem("consultant.name");
    localStorage.removeItem("consultant.email");
    localStorage.removeItem("consultant.role");
    window.location.replace("/consultant");
  };

  const checkToken = async () => {
    try {
      setLoading(true);
      const { data } = await api.get(`/user/isTokenValid`, {
        tokenType: type,
      });
      if (data?.message !== "Valid") {
        if (type == "user") {
          logoutUser();
        } else if (type === "consultant") {
          logoutConsultant();
        } else {
          logoutCandidate();
        }
      }
    } catch (err) {
      console.error(err);
      if (type == "user") {
        logoutUser();
      } else if (type === "consultant") {
        logoutConsultant();
      } else {
        logoutCandidate();
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkToken();
  }, []);

  return { loading, setLoading };
};

export default useTokenValidation;
